import React, { useState, useEffect } from "react";
import Sidebar from "../Sidebar";
import ApplicationForm from "../ApplicationForm";
import Offers from "../Offers";
import PopularDestination from "../PopularDestination";
import Header from "../../Header/Header";
import Footer from "../../Footer/Footer";
import DomesticPackages from "../Pakages/DomesticPakages";
import InternationalPakages from "../Pakages/InternationalPakages";
import PanIndia from "../Pakages/PanIndia";
import EuropePakages from "../Pakages/EuropePakages";
import ReligiousPakages from "../Pakages/ReligiousPakages";

function Content() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  const [isOpen, setIsOpen] = useState(false);

  return (
    <div className="h-screen flex flex-col">

      <Sidebar isOpen={isOpen} setIsOpen={setIsOpen} />


      <div
        className={`transition-all duration-300 mt-[72px] 
          ${isOpen ? "ml-0 sm:ml-56" : "ml-0 sm:ml-16"}
        `}
      >
        <Header isOpen={isOpen} setIsOpen={setIsOpen} />


        <ApplicationForm />
        <Offers />
        <DomesticPackages />
        <ReligiousPakages />
        <InternationalPakages />
        <EuropePakages />
        <PanIndia />
        <PopularDestination />
        <Footer />
      </div>


      {isOpen && (
        <div
          className="fixed inset-0 bg-black bg-opacity-40 sm:hidden z-30"
          onClick={() => setIsOpen(false)}
        ></div>
      )}
    </div>
  );
}

export default Content;
